/**
 * Sanitiza el nombre de un archivo antes de subirlo a S3.
 *
 * Además de limpiar caracteres inválidos, recorta el nombre base a un máximo
 * seguro: la URL final (dominio + carpeta + timestamp + nombre) se persiste en
 * columnas varchar(255) del backend, y nombres de archivo muy largos (p. ej.
 * imágenes descargadas de redes sociales con tokens de ~200 chars) hacían
 * fallar la creación de embudos con "value too long for type varchar(255)".
 */
const MAX_BASENAME_LENGTH = 40;

export const sanitizeUploadFilename = (filename: string): string => {
  const dotIndex = filename.lastIndexOf(".");
  const rawBase = dotIndex > 0 ? filename.slice(0, dotIndex) : filename;
  const rawExtension = dotIndex > 0 ? filename.slice(dotIndex + 1) : "";

  const clean = rawBase
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9._-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, MAX_BASENAME_LENGTH)
    .replace(/^-|-$/g, "");

  const extension = rawExtension
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "")
    .slice(0, 10);

  const base = clean || "archivo";
  return extension ? `${base}.${extension.toLowerCase()}` : base;
};
